module.exports = __webpack_public_path__ + "static/media/break-free.0bf002ec.png";